<template>
    <div class="sumbit-form">
        <el-form :ref="ref" class="form" :model="value" :rules="rules" :key="ref">
            <div v-for="(item,index) in list" :key="index" class="item">
                <template v-if="item.type == 'input'||item.type == 'number'||item.type == 'password'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" size="small" :style="'width:'+(item.valueWidth?item.valueWidth:'215px')"></el-input>
                        <span class="tip">{{item.tip}}</span>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'text'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <span class="">{{value[item.name]}}</span>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'getCode'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" size="small" :style="'width:'+(item.valueWidth?item.valueWidth:'215px')"></el-input>
                        <el-button type="primary" size="small" @click="captchaButtonClick">{{captchaFont}}</el-button>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'imageCode'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" size="small" :style="'width:'+(item.valueWidth?item.valueWidth:'215px')"></el-input>
                        <img
                            @click="getImageCode"
                            :src="imageCodeUrl"
                            fit="cover"
                            class="imageCode"/>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'textarea'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:'+(item.valueWidth?item.valueWidth:'550px')" size="small"></el-input>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'table1'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <div class="row">
                            <el-button type="primary" size="small" icon="el-icon-circle-plus" @click="item.addFun">新增</el-button>
                        </div>
                        <el-table
                            :data="value[item.name]"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                            <el-table-column prop="dutyName" label="险别名称" align="center" width="244">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.dutyName" placeholder="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="payLimit" label="保额/限额" align="center" width="140">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.payLimit" placeholder="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="premium" label="标准保费" align="center" width="140">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.premium" placeholder="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80px" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="item.delFun(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:'+(item.valueWidth?item.valueWidth:'550px')" size="small"></el-input> -->
                    </el-form-item>
                </template>
                <template v-if="item.type == 'table'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <div class="row">
                            <el-button type="primary" size="small" icon="el-icon-circle-plus" @click="item.addFun">新增</el-button>
                        </div>
                        <el-table
                            :data="value[item.name]"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                            <el-table-column prop="kindName" label="险别名称" align="center" width="244">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.kindName" placeholder="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amount" label="保额/限额" align="center" width="140">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.amount" placeholder="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="benchmarkPremium" label="标准保费" align="center" width="140">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.benchmarkPremium" placeholder="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80px" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="item.delFun(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:'+(item.valueWidth?item.valueWidth:'550px')" size="small"></el-input> -->
                    </el-form-item>
                </template>

                <template v-if="item.type == 'select'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" :key="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" size="small" filterable>
                            <el-option
                            v-for="oitem in item.options"
                            :key="oitem[item.optionsValue?item.optionsValue:'value']"
                            :label="oitem[item.optionsLable?item.optionsLable:'label']"
                            :value="oitem[item.optionsValue?item.optionsValue:'value']">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'select2'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" :key="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" size="small" filterable>
                            <el-option
                            v-for="oitem in item.options"
                            :key="oitem"
                            :label="oitem"
                            :value="oitem">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'select3'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" size="small" filterable>
                            <el-option
                            v-for="oitem in options"
                            :key="oitem.lable"
                            :label="oitem.lable"
                            :value="oitem.lable">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'selectList'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" multiple size="small" filterable>
                            <el-option
                            v-for="oitem in item.options"
                            :key="oitem[item.optionsValue?item.optionsValue:'value']"
                            :label="oitem[item.optionsLable?item.optionsLable:'label']"
                            :value="oitem[item.optionsValue?item.optionsValue:'value']">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'selectBtn'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:215px'" size="small" disabled></el-input>
                        <el-button type="primary" size="small" @click="item.btnFunction">{{item.btnName}}</el-button>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'address'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-cascader
                        size="small"
                        placeholder="请选择"
                        :options="regionData"
                        v-model="value[item.name]"
                        >
                        </el-cascader>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'provinceAndCity'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-cascader
                        size="small"
                        placeholder="请选择"
                        :options="provinceAndCityData"
                        v-model="value[item.name]"
                        @change="item.func"
                        >
                        </el-cascader>
                    </el-form-item>
                </template>
                
                <template v-if="item.type == 'dateList'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>
                
                <template v-if="item.type == 'date'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'switch'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <!-- <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期"
                    >
                        </el-date-picker> -->
                        <el-switch v-model="value[item.name]"></el-switch>
                    </el-form-item>
                </template>
                
                <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" v-if="item.type == 'checkbox'">
                    <el-checkbox-group v-model="value[item.name]">
                        <el-checkbox :label="row.label" v-for="(row,index) in item.options" :key="index"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" v-if="item.type == 'header'" style="width:344px">
                    <div class="header">
                        <el-upload
                            action=""
                            Multiple
                            :show-file-list="false"
                            :http-request="item.func"
                            >
                            <el-button type="primary" icon="el-icon-upload" size="small" style="margin-right: 10px">上传图片</el-button>
                        </el-upload>
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="value[item.name]"
                        :preview-src-list="[value[item.name]]"
                        v-if="value[item.name]"
                        fit="cover"></el-image>
                    </div>
                </el-form-item>
                <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" v-if="item.type == 'headerlook'" style="width:600px">
                    <div class="header">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="value[item.name]"
                        :preview-src-list="[value[item.name]]"
                        v-if="value[item.name]"
                        fit="cover"></el-image>
                    </div>
                </el-form-item>
                <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name" v-if="item.type == 'cropper'" style="width:600px">
                    <div class="cropper">
                        <div class="cropper-btn" v-if="!item.isDetail">
                            <el-upload
                                action=""
                                Multiple
                                :show-file-list="false"
                                :http-request="item.func"
                                >
                                <el-button type="primary" icon="el-icon-upload" size="small" style="margin-right: 10px">上传图片</el-button>
                            </el-upload>
                            
                            <el-button type="primary" icon="el-icon-scissors" size="small" style="margin-right: 10px;margin-top: 2px;" @click="item.cropperFun" v-if="value[item.name]">裁剪图片</el-button>
                        </div>
                        <el-image
                        style="width: 97px; height: 97px;margin-right: 10px;border-radius: 4px;"
                        :src="value[item.name]"
                        :preview-src-list="[value[item.name]]"
                        v-if="value[item.name]"
                        fit="cover"></el-image>
                        
                        

                        <!-- <i class="el-icon-scissors scissors" @click="item.cropperFun" v-if="value[item.name]"></i> -->

                    </div>
                </el-form-item>
            </div>
            
            <div class="btns" v-if="btns.length>0">
                <el-button
                    v-for="(item, index) in btns"
                    :key="index"
                    :size="item.size?item.size:'small'"
                    :type="item.type"
                    :icon="item.icon"
                    @click.stop.prevent="item.handleClick"
                    >{{ item.name }}
                </el-button>
            </div>
            
        </el-form>
    </div>
</template>

<script>
    import api from '../../api/login'
    import {isPhoneNumber} from '../../utils/index'
    import { provinceAndCityData , regionData , CodeToText } from "element-china-area-data";
    export default {
        computed: {
        },
        data() {
            return {
                regionData:regionData,
                isSearchLock: true,
                provinceAndCityData:provinceAndCityData,
                captchaFont: '获取验证码',
                totalTime: 60,
                timer: null,
                rulesText: '',
                regCodeText:'',

            }
        },
        props:{
            ref:{
                type: String,
                default: 'formList'
            },
            list:{
                type: Array,
                default: () => []
            },
            rules: {
                type: Object,
                default: () => {}
            },
            value: {
                type: Object,
                default: () => {}
            },
            labelWidth:{
                type: String,
                default: '150px'
            },
            imageCodeUrl:{
                type: String,
                default: ''
            },
            btns:{
                type: Array,
                default: () => []
            },
            getImageCode:{
                type: Function,
                default: () => {
                }
            },
            

        },
        
        watch: {
            
        },
        created() {

        },
        mounted() {
           
        },
        methods: {
            // table表头样式
            tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
                if (rowIndex === 0) {
                    return 'background-color: #F2F2F2;color: #000;'
                }
            },
            //子组件校验，传递到父组件
            validateForm() {
                let flag = null;
                if (this.isSearchLock) {
                    this.$refs[this.ref].validate(valid => {
                    let vm = this;
                    if (valid) {
                        flag = true;
                        vm.isSearchLock = flag;
                    } else {
                        flag = false;
                        vm.isSearchLock = flag;
                        this.$message.error("信息不完整，请继续填写完整");
                        setTimeout(function() {
                            vm.isSearchLock = true;
                        }, 2000);
                    }
                    });
                    return flag;
                }
            },
            resetFields() {
                console.log(this.ref);
                this.$refs[this.ref].resetFields();
            },
            async captchaButtonClick() {
                
                if(!isPhoneNumber(this.value.phone)){
                    this.$message({
                        showClose: true,
                        message: '错了哦，账号不是手机号!',
                        type: 'error'
                    });
                    return;
                }
                if (this.captchaFont != '获取验证码') return
                console.log('sendCode')

                let res = await api.sendCode({
                    phone:this.value.phone,
                    imageCode:this.value.imageCode,
                    fileName:this.value.fileName,
                });
                console.log(res.data)
                if(res.data.code == '200'){
                    this.code = res.data.Msg
                    this.countdown();
                }
                
            },
            // 倒计时
            countdown() {
                this.captchaFont = this.totalTime + '秒'
                this.timer = window.setInterval(() => {
                this.totalTime--
                this.rulesText = '验证码已发送'
                if (this.totalTime !== 0) {
                    this.captchaFont = this.totalTime + '秒'
                } else {
                    this.cleanTimer()
                }
                }, 1000)
            },
            cleanTimer() {
                window.clearInterval(this.timer)
                this.totalTime = 60
                this.captchaFont = '获取验证码'
                this.rulesText = ''
            },
        }

    }
</script>

<style lang="scss" scoped>
    .form{
        display: flex;
        flex-wrap: wrap;
        .item{
            display: flex;
            position: relative;
            .tip{
                color:red;
                font-size: 12px;
                margin-left: 10px;
            }
        }
        .header{
            display: flex;
            align-items: center;
            /deep/.el-form-item__content{
                margin-left: 0px !important;
                display: flex;
            }
        }
        .cropper{
            /deep/.el-form-item__content{
                margin-left: 0px !important;
            }
            .cropper-btn{
                display: flex;
                align-items: center;
                margin-bottom: 6px;
            }
        }
        .btns{
            width: 100%;
            display: flex;
            justify-content: center;
            /deep/.el-button{
                // margin: 0 10px;
            }
        }
        .imageCode{
            width: 92px;
            height: 32px;
            margin-top: 4px;
            position: absolute;
            right: -92px;
            top: 0;

        }
        .row{
            width: 100%;
            display: flex;
            flex-direction: row-reverse;
            margin-bottom: 10px;
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
    }
    .scissors{
        cursor: pointer;
    }
</style>